document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-scroll]').forEach((element) => {
    element.addEventListener('click', (event) => {
      const id = element.getAttribute('href');

      if (id?.startsWith('#')) {
        event.preventDefault();
        document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  document.querySelectorAll('[data-collection-toolbar]').forEach((toolbar) => {
    if (toolbar.dataset.enforceInStock !== 'true' || window.Shopify?.designMode) return;

    const url = new URL(window.location.href);

    if (!url.searchParams.has('filter.v.availability')) {
      url.searchParams.set('filter.v.availability', '1');
      window.location.replace(url.toString());
    }
  });

  document.querySelectorAll('[data-add-to-cart]').forEach((form) => {
    const button = form.querySelector('[data-add-to-cart-button]');
    const status = form.querySelector('[data-add-to-cart-status]');

    if (!button || !status) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (button.disabled) return;

      const originalLabel = button.textContent.trim();
      const addingLabel = button.dataset.addingLabel || originalLabel;
      const addedLabel = button.dataset.addedLabel || originalLabel;
      const rootUrl = window.Shopify?.routes?.root || '/';

      button.disabled = true;
      button.textContent = addingLabel;
      status.textContent = '';
      status.classList.remove('is-error');

      try {
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message || 'Unable to add this item.');
        }

        const cartResponse = await fetch(`${rootUrl}cart.js`, {
          headers: {
            Accept: 'application/json'
          }
        });
        const cart = await cartResponse.json();

        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
        });

        button.textContent = addedLabel;
        status.textContent = addedLabel;

        window.setTimeout(() => {
          button.textContent = originalLabel;
          button.disabled = false;
        }, 1400);
      } catch (error) {
        status.textContent = error.message;
        status.classList.add('is-error');
        button.textContent = originalLabel;
        button.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-csv-upload]').forEach((form) => {
    const input = form.querySelector('[data-csv-input]');
    const fileName = form.querySelector('[data-file-name]');

    if (!input || !fileName) return;

    input.addEventListener('change', () => {
      const file = input.files?.[0];
      input.setCustomValidity('');

      if (!file) {
        fileName.textContent = 'No file selected';
        return;
      }

      const isCsv = file.name.toLowerCase().endsWith('.csv');
      const maxBytes = Number(input.dataset.maxBytes);

      if (!isCsv) {
        input.setCustomValidity(input.dataset.invalidMessage || 'Please select a CSV file.');
      } else if (maxBytes && file.size > maxBytes) {
        input.setCustomValidity(input.dataset.tooLargeMessage || 'That file is too large.');
      }

      fileName.textContent = file.name;

      if (!input.checkValidity()) input.reportValidity();
    });
  });
});
